import React from 'react';

import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 20px;
  margin-top: 150px;

  @media (max-width: 768px) {
    margin-top: 50px;
  }
`;

const TextBox = styled.div`
  text-align: center;
`;

const Title = styled.h2`
  margin: 0;
`;

const Description = styled.div`
  max-width: 488px;
  color: var(--text-secondary);
  text-align: center;
  margin-top: 5px;
`;

const AlertsNotFound = () => {
  return (
    <Container data-test-id="alerts-empty-state">
      <img src="/icons/ai-blob.svg" style={{ width: '29px', height: '29px' }} alt="ai-insights" />
      <TextBox>
        <Title>No alerts yet. Stay tuned.</Title>
        <Description>New alerts will appear here as competitive and market changes are detected.</Description>
      </TextBox>
    </Container>
  );
};

export default AlertsNotFound;
